export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-volume-strike-85c7d24dcbd5d1dcf4567a257b5d9f63.svg";